export default __webpack_public_path__ + "e70722c0fe0ac3d4227b9147987a6526.svg";